import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Table, Button, Form, Row, Col, Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import GuestModal from "./GuestModal";
import useFormDraft from "../../../hooks/useFormDraft";
import useApiError from "../../../hooks/useApiError";

export default function GuestsMaster() {

  const userData = useSelector((state) => state.authentication.userData);

  const API_BASE = process.env.REACT_APP_COLLEGE_ERP_API;
    const handleApiError = useApiError();

  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [editingGuest, setEditingGuest] = useState(null);
const {
  formData,
  setFormData,
  clearDraft
} = useFormDraft("guestDraft", {
  firstName: "",
  lastName: "",
  fullName: "",
  mobile: "",
  email: "",
  gender: "",
  dob: "",
  address: "",
  city: "",
  state: "",
  country: "India",
  pincode: "",
  idProofType: "",
  idProofNumber: "",
  idProofFile: "",
  vipStatus: false,
  loyaltyPoints: 0,
  specialRequests: "",
  blacklisted: false,
  notes: ""
});

  /* ================= FETCH GUESTS ================= */

  const fetchGuests = async () => {
    try {

      setLoading(true);

      const res = await axios.get(
        `${API_BASE}guests?branch=${userData.branch}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`
          }
        }
      );
     
      setGuests(res.data);

    } catch (err) {
       handleApiError(err.response?.data);
      console.error("Guest fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userData?.branch && userData?.token) {
      fetchGuests();
    }
  }, [userData]);

  /* ================= HANDLE CHANGE ================= */

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  /* ================= SAVE GUEST ================= */

  const saveGuest = async () => {
    try {

      if (!formData.mobile) {
        alert("Mobile required");
        return;
      }

      if (editingGuest) {

        await axios.patch(
          `${API_BASE}guests/${editingGuest._id}`,
          {
            ...formData,
            branch: userData.branch
          },
          {
            headers: {
              Authorization: `Bearer ${userData.token}`
            }
          }
        );

      } else {

        await axios.post(
          `${API_BASE}guests/${userData.branch}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`
            }
          }
        );
      }

      setShowModal(false);
      resetForm();
      fetchGuests();

    } catch (error) {
      alert(error.response?.data?.message || "Guest save failed");
    }
  };

  /* ================= EDIT ================= */

  const handleEdit = (guest) => {

    setEditingGuest(guest);

    setFormData({
      firstName: guest.firstName || "",
      mobile: guest.mobile || "",
      email: guest.email || "",
      city: guest.city || "",
      idProofType: guest.idProofType || "",
      idProofNumber: guest.idProofNumber || ""
    });

    setShowModal(true);
  };

  /* ================= RESET ================= */

  const resetForm = () => {

    setEditingGuest(null);

    setFormData({
      firstName: "",
      mobile: "",
      email: "",
      city: "",
      idProofType: "",
      idProofNumber: ""
    });
  };

  /* ================= SEARCH FILTER ================= */

  const filteredGuests = guests.filter((g) =>
    `${g.firstName} ${g.mobile}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="container mt-4">

      <Row className="mb-3">
        <Col>
          <h4 className="fw-bold">Guests Master</h4>
        </Col>

        <Col className="text-end">

          <Button
            onClick={() => {
              resetForm();
              setShowModal(true);
            }}
          >
            Add Guest
          </Button>

        </Col>
      </Row>

      <Card className="shadow-sm">
        <Card.Body>

          <Row className="mb-3">

            <Col md={4}>
              <Form.Control
                placeholder="Search name or mobile"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>

          </Row>

          {loading ? (
            <Spinner animation="border" />
          ) : (

            <Table bordered hover responsive>

              <thead>
                <tr>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Email</th>
                  <th>City</th>
                  <th>ID Proof</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>

                {filteredGuests.map((guest) => (

                  <tr key={guest._id}>

                    <td>{guest.firstName}</td>
                    <td>{guest.mobile}</td>
                    <td>{guest.email}</td>
                    <td>{guest.city}</td>
                    <td>
                      {guest.idProofType} {guest.idProofNumber}
                    </td>

                    <td>

                      <Button
                        size="sm"
                        variant="warning"
                        onClick={() => handleEdit(guest)}
                      >
                        Edit
                      </Button>

                    </td>

                  </tr>

                ))}

              </tbody>

            </Table>

          )}

        </Card.Body>
      </Card>

      {/* ================= MODAL ================= */}

      <GuestModal
showModal={showModal}
setShowModal={setShowModal}
editingGuest={editingGuest}
setEditingGuest={setEditingGuest}
formData={formData}
setFormData={setFormData}
clearDraft={clearDraft}
fetchGuests={fetchGuests}
API_BASE={API_BASE}
userData={userData}
/>

    </div>
  );
}